module.exports = __webpack_public_path__ + "img/pill.a827df52.svg";